import _ from 'underscore';

export const DefaultImageAltText = 'Image';

export const FieldType = {
  DisplayText: 'DisplayText',
  AltText: 'AltText',
};

export const FieldLimit = {
  DisplayText: 35,
  AltText: 90,
};

const requiredValidateFunc = val => _.size(val) > 0 && val.trim() !== '';

export const fieldsConfig = [
  {
    type: FieldType.DisplayText,
    limit: FieldLimit.DisplayText,
    labelKeyForLocalization: _TL_('Name/Display Text'),
    helpTopic: 'pop_BA_ImageExtension_Name',
    description: _TL_('Display text appears to customers as a caption below images in the multi-image layout.'),
  },
  {
    type: FieldType.AltText,
    limit: FieldLimit.AltText,
    labelKeyForLocalization: _TL_('Image Alt Text (required)'),
    helpTopic: 'pop_BA_NewAdCreate_AltText',
    description: _TL_('Alt text appears when customers hover over the image on search results pages.'),
    required: true,
    validators: [
      {
        validate: requiredValidateFunc,
        msg: _TL_('Image Alt Text is required.'),
      },
    ],
  },
];

const runValidators = (value, validators) => {
  for (let i = 0; i < _.size(validators); i += 1) {
    const { validate, msg } = validators[i];
    if (!validate(value)) {
      return msg;
    }
  }

  return '';
};

export const validateAllFields = (fieldValues, callback) => {
  const errors = {};
  _.each(fieldsConfig, ({ validators, type }) => {
    const msg = runValidators(fieldValues[type], validators);

    if (msg) {
      errors[type] = msg;
    }
  });

  callback(errors);

  return errors;
};

export const validateField = (fieldType, fieldValue, callback) => {
  const errors = {};
  const fieldConfig = _.find(fieldsConfig, field => field.type === fieldType);
  const msg = runValidators(fieldValue, fieldConfig.validators);

  if (msg) {
    errors[fieldConfig.type] = msg;
  }

  callback(errors);

  return errors;
};
